import { NgModule } from '@angular/core';
import { PaypalComponent } from './paypal.component';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    imports: [
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    declarations: [PaypalComponent],
    exports: [PaypalComponent]
})
export class PaypalModule {}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/paypal/paypal.module.ts